//          ⢠⣿⣋⣿⣿⣉⣿⣿⣯⣧⡰
//          ⣿⣿⣹⣿⣿⣏⣿⣿⡗⣿⣿
//          ⠟⡛⣉⣭⣭⣭⠌⠛⡻⢿⣿
//          ⠄⠄⣤⡌⣿⣷⣯⣭⣿⡆⣈
//           ⢻⣿⣿⣿⣿⣿⣿⣿⣷⢛
//            ⢻⣷⣽⣿⣿⣿⢿⠃⣼⣧⣀
//              ⣛⣻⣿⠟⣀⡜⣻⢿⣿⣿⣶⣤⡀
//            ⢠⣤⣀⣨⣥⣾⢟⣧⣿⠸⣿⣿⣿⣿⣿⣤⡀
//            ⢟⣫⣯⡻⣋⣵⣟⡼⣛⠴⣫⣭⣽⣿⣷⣭⡻⣦⡀
//           ⢰⣿⣿⣿⢏⣽⣿⢋⣾⡟⢺⣿⣿⣿⣿⣿⣿⣷⢹⣷⠄
//           ⣿⣿⣿⢣⣿⣿⣿⢸⣿⡇⣾⣿⠏⠉⣿⣿⣿⡇⣿⣿⡆
//           ⣿⣿⣿⢸⣿⣿⣿⠸⣿⡇⣿⣿⡆⣼⣿⣿⣿⡇⣿⣿⡇
//           ⠘⣿⣿⡘⣿⣿⣷⢀⣿⣷⣿⣿⡿⠿⢿⣿⣿⡇⣩⣿⡇
// ⣿⣿⠃        ⢻⣷⠙⠛⠋⣿⣿⣿⣿⣿⣷⣶⣿⣿⣿⡇⣿⣿⡇

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { regFile } from './utils/regFile';
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);
import VueSimpleVerify from 'vue-simple-verify'
import '../node_modules/vue-simple-verify/dist/vue-simple-verify.css';
Vue.component('vue-simple-verify', VueSimpleVerify)
import {
  Breadcrumb,
  Upload,
  Button,
  Icon,
  message,
  Avatar,
  Table,
  DatePicker,
  Tree,
  Card,
  Modal,
  Input,
  Select,
  Popconfirm,
  Radio,
  Affix,
  Checkbox,
  Tooltip,
  Spin,
  Tag,
  Pagination,
  Form,
  Tabs,
  InputNumber,
  FormModel,
  Descriptions,
  Progress,
  Switch,
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

Vue.use(Tag);
Vue.use(Breadcrumb);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Avatar);
Vue.use(Table);
Vue.use(DatePicker);
Vue.use(Tree);
Vue.use(Card);
Vue.use(Modal);
Vue.use(Input);
Vue.use(Select);
Vue.use(Popconfirm);
Vue.use(Radio);
Vue.use(Affix);
Vue.use(Checkbox);
Vue.use(Tooltip);
Vue.use(Spin);
Vue.use(Pagination);
Vue.use(Form);
Vue.use(Tabs);
Vue.use(InputNumber);
Vue.use(FormModel);
Vue.use(Descriptions);
Vue.use(Progress);
Vue.use(Switch);
Vue.prototype.$regFile = regFile;
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.config.productionTip = false;
Vue.config.devtools = true;

/* 过滤器 */ 
import * as filters from '@/utils/roleFilter.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 设置属性换肤
import {roleFilterClass} from '@/utils/roleFilter.js'
window.document.documentElement.setAttribute('data-theme', roleFilterClass(store.state.region))

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
